export enum GenericWalkthroughColor {
  Primary = 'primary',
  Dark = 'dark'
}

export enum GenericWalkthroughPointer {
  Left = 'left',
  Right = 'right',
  Up = 'up',
  Down = 'down',
  None = 'none'
}

export enum GenericWalkthroughFooter {
  Steps = 'steps',
  TwoButtons = 'two-buttons',
  OneButton = 'one-button'
}
